module.exports = __webpack_public_path__ + "img/ship-rocket.be78b2d5.png";